import React from "react";
import "./JibuIntegrations.css";
import { FaGlobe, FaCode, FaDatabase } from "react-icons/fa";

const JibuIntegrations = ({ isDarkMode }) => {
  return (
    <section className={`jibu-integrations ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Seamless Integrations</h2>
      <p className="subtext">JibuBot connects with your favorite tools and platforms.</p>

      <div className="integrations-grid">


        <div className="integration-card">
          <FaGlobe className="icon" />
          <h3>Website Chat</h3>
          <p>Embed JibuBot seamlessly into your website and start conversations instantly.</p>
        </div>


        <div className="integration-card">
          <FaCode className="icon" />
          <h3>Custom APIs</h3>
          <p>Integrate JibuBot into your backend with flexible APIs and webhooks.</p>
        </div>

        <div className="integration-card">
          <FaDatabase className="icon" />
          <h3>CRM Tools</h3>
          <p>Personalize interactions by connecting JibuBot with your CRM data.</p>
        </div>
      </div>
    </section>
  );
};

export default JibuIntegrations;
